(function() {
    //View control dropdown
    var $dropDownContainer = $('.read-btn-container');
    var $dropDownBtn = $('.btn-label', $dropDownContainer);
    var $closeBtn = $('._close', $dropDownContainer);

    $dropDownBtn.on('click', function(){
        $dropDownContainer.toggleClass('_show');
    });

    $closeBtn.on('click', function(){
        $dropDownContainer.removeClass('_show');
    });

    //Book item dropdown
    var $bookItemDropDownContainer = $('.book-item--dropdown-container');
    var $bookItemDropDownBtn = $('.book-item--dropdown-btn', $bookItemDropDownContainer);

    $bookItemDropDownBtn.on('click', function(){
        $(this).parent().toggleClass('_show');
        $(this).toggleClass('active');
    });

    //$('.select').fancySelect();

    // Setup trumbowyg editor missing locale string and upload url
    jQuery.trumbowyg.langs.ru.upload = 'Загрузить изображение';
    $.trumbowyg.upload.serverPath ='/api/user_uploads';
    $.trumbowyg.upload.fileFieldName = 'image';

    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
            if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
                // Send the token to same-origin, relative URLs only.
                // Send the token only if the method warrants CSRF protection
                // Using the CSRFToken value acquired earlier
                xhr.setRequestHeader("X-CSRFToken", csrftoken);
            }
        }
    });

    $.trumbowyg.upload.error = function(data) {
        messages.error(data.responseJSON);
    }

}());
